import React, { useEffect, useState } from 'react';
import { PageTitle } from '../../_metronic/layout/core';
import { NavButtonGroup } from './index';
import { useSelector } from 'react-redux';
import { reduxProps } from '../../constants';
import {toast} from 'react-toastify';
import './ClassShare.scss';

export function ClassShare() {
  const { classroom } = useSelector((state: reduxProps) => state.educationReducer);
  const [classCode, setClassCode] = useState('');
  const [deepLink] = useState('kidly://app/get-student-code/' + classroom.classroomCode);

  useEffect(() => {
    if (classroom && classroom.classroomCode) {
      setClassCode(classroom.classroomCode);
      console.log('classroomtest',  classroom);
    }
  }, [classroom]);

  const handleCopyCode = async () => {
    try {
      await navigator.clipboard.writeText(classCode);
      toast.success('Sınıf kodu kopyalandı!', {
        autoClose: 2000,
        position: 'top-right',
      });
    } catch (err) {
      toast.error('Kopyalama işlemi başarısız!', {
        autoClose: 2000,
        position: 'top-right',
      });
    }
  };

  const handleShareCode = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: 'Sınıf Kodu',
          text: `Sınıf kodum: ${classCode}`,
        });
      } else {
        await navigator.clipboard.writeText(`Sınıf kodum: ${classCode}`);
        toast.success('Sınıf kodu kopyalandı!', {
          autoClose: 2000,
          position: 'top-right',
        });
      }
    } catch (err) {
      toast.error('Paylaşım işlemi başarısız!', {
        autoClose: 2000,
        position: 'top-right',
      });
    }
  };

  const handleShareLink = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: 'Sınıf Linki',
          text: `Sınıf linki: ${deepLink}`,
        });
      } else {
        await navigator.clipboard.writeText(deepLink);
        toast.success('Link kopyalandı!', {
          autoClose: 2000,
          position: 'top-right',
        });
      }
    } catch (err) {
      toast.error('Link paylaşımı başarısız!', {
        autoClose: 2000,
        position: 'top-right',
      });
    }
  };

  const handleShareQR = async () => {
    try {
      if (navigator.share) {
        // QR kod görselini de paylaş
        try {
          const response = await fetch(`kidly://app/get-student-code/${classroom.classroomCode}/qr.png`);
          const blob = await response.blob();
          const file = new File([blob], 'qr.png', { type: 'image/png' });

          await navigator.share({
            title: 'Sınıf QR Kodu',
            text: `Sınıf linki: ${deepLink}`,
            files: [file]
          });
        } catch (fileError) {
          // Dosya paylaşımı başarısız olursa sadece metin paylaş
          await navigator.share({
            title: 'Sınıf QR Kodu',
            text: `Sınıf linki: ${deepLink}`,
          });
        }
      } else {
        // Fallback: QR kod görselini indir
        const link = document.createElement('a');
        link.href = `kidly://app/get-student-code/${classroom.classroomCode}/qr.png`;
        link.download = 'qr-code.png';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success('QR kod indirildi!', {
          autoClose: 2000,
          position: 'top-right',
        });
      }
    } catch (err) {
      toast.error('QR kod paylaşımı başarısız!', {
        autoClose: 2000,
        position: 'top-right',
      });
    }
  };

  return (
    <div id='class-share'>
      <PageTitle description={'Bu sınıfa ait öğrencileri görebilir, değişiklikler yapabilirsiniz.'}>
        Sınıfı Paylaş
      </PageTitle>

      <NavButtonGroup/>

      <div className='card'>
        <div className='card-body py-8'>
          <div className='text-center mb-8'>
            <h2>Sınıfı Paylaş</h2>
            <p>
              Sınıf kodunu öğrencilerinizle paylaşabilirsiniz. Sınıf kodunu link veya kare-kod olarak da paylaşabilirsiniz.
            </p>
          </div>

          {/* Sınıf Kodu Alanı */}
          <div className='d-flex flex-column align-items-center mb-8'>
            <div className='box-group dashed-box'>
              <span>Sınıf Kodu: <b>{classCode}</b></span>
            </div>

            <div className='action-buttons box-group'>
            <button
              onClick={handleCopyCode}
              className='btn btn-light-primary'
            >
              <i className='fas fa-copy me-2'></i>
              Kodu Kopyala
            </button>
            <button
              onClick={handleShareCode}
              className='btn btn-primary'
            >
              <i className='fas fa-share me-2'></i>
              Kodu Paylaş
            </button>
          </div>
          </div>

          {/* Kodu Kopyala ve Paylaş Butonları */}
          

          {/* Deep Link Alanı */}

          <div className='d-flex flex-column align-items-center mb-8 deep-link-section'>
              <div className='box-group'>
                <a href={deepLink} target='_blank' className='deep-link-label' rel='noopener noreferrer'>{deepLink}</a>
              </div>
            <div className='box-group'>
              <button
                onClick={handleShareLink}
                className='btn btn-outline-primary full-width'
              >
                <i className='fas fa-share me-2'></i>
                Link olarak Paylaş
              </button>
            </div>
          </div>

          {/* QR Kod */}
          <div className='d-flex flex-column align-items-center qr-code-section'>
            <div className='box-group'>
              <img
                src={`https://production.gokidly.com/education/api/v3/classroom/${classroom.classroomCode}/qr.png`}
                alt='QR Code'
                className='qr-code-image'
              />
            </div>
            <div className='box-group'> 
            <button
              onClick={handleShareQR}
              className='btn btn-outline-primary full-width'
            >
              <i className='fas fa-share me-2'></i>
              QR Kodu Paylaş
            </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
